export default class BlockSliderImageBackgroundText {
	constructor() {

		let blocks = document.querySelectorAll('.block-slider-image-background-text');

		blocks.forEach((block) => {
			const swiper = block.querySelector('.swiper');
			const navigation = block.querySelector('.swiper-navigation');

			new Swiper(swiper, {
				slidesPerView: "1",
				grabCursor: true,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				pagination: {
					el: navigation,
					type: 'bullets',
					bulletElement: 'span',
					clickable: true
				}
			});
		});
	}
}
